export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  createdDate: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSONObject']['output']>;
  details?: Maybe<ActivityDetails>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: ActivityTypeEnum;
  user?: Maybe<User>;
};

export type ActivityCustomProps = {
  __typename?: 'ActivityCustomProps';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityDetails = {
  __typename?: 'ActivityDetails';
  customProps?: Maybe<Array<Maybe<ActivityCustomProps>>>;
};

export type ActivityFindInput = {
  resourceId: Scalars['ID']['input'];
  resourceType: ActivityResourceType;
};

export enum ActivityResourceType {
  Form = 'FORM',
  Observation = 'OBSERVATION',
  ProjectFile = 'PROJECT_FILE',
  Task = 'TASK'
}

export enum ActivityTypeEnum {
  ActivityFormCommentAdd = 'ACTIVITY_FORM_COMMENT_ADD',
  ActivityFormCommentDelete = 'ACTIVITY_FORM_COMMENT_DELETE',
  ActivityFormCreate = 'ACTIVITY_FORM_CREATE',
  ActivityFormStatusChange = 'ACTIVITY_FORM_STATUS_CHANGE',
  ActivityFormUpdate = 'ACTIVITY_FORM_UPDATE',
  ActivityObservationCommentAdd = 'ACTIVITY_OBSERVATION_COMMENT_ADD',
  ActivityObservationCommentDelete = 'ACTIVITY_OBSERVATION_COMMENT_DELETE',
  ActivityObservationCreate = 'ACTIVITY_OBSERVATION_CREATE',
  ActivityObservationFileAdd = 'ACTIVITY_OBSERVATION_FILE_ADD',
  ActivityObservationStatusChange = 'ACTIVITY_OBSERVATION_STATUS_CHANGE',
  ActivityObservationUpdate = 'ACTIVITY_OBSERVATION_UPDATE',
  ActivityProjectFileCommentAdd = 'ACTIVITY_PROJECT_FILE_COMMENT_ADD',
  ActivityProjectFileCommentDelete = 'ACTIVITY_PROJECT_FILE_COMMENT_DELETE',
  ActivityProjectFileCreate = 'ACTIVITY_PROJECT_FILE_CREATE',
  ActivityProjectFileStatusChange = 'ACTIVITY_PROJECT_FILE_STATUS_CHANGE',
  ActivityProjectFileUpdate = 'ACTIVITY_PROJECT_FILE_UPDATE',
  ActivityProjectFileValidationRequestAvailable = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_AVAILABLE',
  ActivityProjectFileValidationRequestCancel = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_CANCEL',
  ActivityProjectFileValidationRequestCreate = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_CREATE',
  ActivityProjectFileValidationRequestNotConcernedByUser = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_NOT_CONCERNED_BY_USER',
  ActivityProjectFileValidationRequestRefused = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_REFUSED',
  ActivityProjectFileValidationRequestRefusedByUser = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_REFUSED_BY_USER',
  ActivityProjectFileValidationRequestValidated = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_VALIDATED',
  ActivityProjectFileValidationRequestValidatedByUser = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_VALIDATED_BY_USER',
  ActivityProjectFileValidationRequestValidatedWithObservation = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_VALIDATED_WITH_OBSERVATION',
  ActivityProjectFileValidationRequestValidatedWithObservationByUser = 'ACTIVITY_PROJECT_FILE_VALIDATION_REQUEST_VALIDATED_WITH_OBSERVATION_BY_USER',
  ActivityTaskCommentAdd = 'ACTIVITY_TASK_COMMENT_ADD',
  ActivityTaskCommentDelete = 'ACTIVITY_TASK_COMMENT_DELETE',
  ActivityTaskCreate = 'ACTIVITY_TASK_CREATE',
  ActivityTaskFileAdd = 'ACTIVITY_TASK_FILE_ADD',
  ActivityTaskStatusChange = 'ACTIVITY_TASK_STATUS_CHANGE',
  ActivityTaskUpdate = 'ACTIVITY_TASK_UPDATE'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ArrayColInput = {
  fields: Array<FormFieldInput>;
  id: Scalars['String']['input'];
};

export type ArrayColModel = {
  __typename?: 'ArrayColModel';
  fields: Array<FormField>;
  id: Scalars['String']['output'];
};

export type ArrayFieldInput = {
  cols: Array<ArrayColInput>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};

export type ArrayFieldModel = {
  __typename?: 'ArrayFieldModel';
  cols: Array<ArrayColModel>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type CheckboxFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options: Array<OptionInput>;
  required: Scalars['Boolean']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CheckboxFieldModel = {
  __typename?: 'CheckboxFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<OptionModel>;
  required: Scalars['Boolean']['output'];
  type: FieldType;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type Comment = {
  __typename?: 'Comment';
  author: User;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  updatedDate: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CommentCreateForProjectFileValidationRequestInput = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  token: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CommentCreateInput = {
  commentableId: Scalars['ID']['input'];
  commentableType: CommentableType;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type CommentDeleteInput = {
  commentId: Scalars['ID']['input'];
};

export type CommentFindInput = {
  commentableId: Scalars['ID']['input'];
  commentableType: CommentableType;
};

export enum CommentableType {
  Form = 'FORM',
  Observation = 'OBSERVATION',
  ProjectFile = 'PROJECT_FILE',
  Task = 'TASK'
}

export type Company = {
  __typename?: 'Company';
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  siren: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type CompanyCreateInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  siren: Scalars['String']['input'];
};

export type CompanyUpdateInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  siren: Scalars['String']['input'];
};

export type CompanysFindInput = {
  projectId: Scalars['ID']['input'];
};

export type CompanysSortInput = {
  companysData: Array<SortedCompanyData>;
  projectId: Scalars['ID']['input'];
};

export type ConfigureOrganizationUserRbacInput = {
  organizationId: Scalars['ID']['input'];
  role: OrganizationRole;
  userId: Scalars['ID']['input'];
};

export type ConfigureProjectUserRbacInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  role: ProjectRole;
  userId: Scalars['ID']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  amount: Scalars['Float']['output'];
  billing?: Maybe<CustomerBilling>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  hasDefaultPaymentMethod: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
};

export type CustomerBilling = {
  __typename?: 'CustomerBilling';
  address?: Maybe<Address>;
};

export type DateFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateFieldModel = {
  __typename?: 'DateFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeleteAllTasksOfCompanyInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type DeleteAllTasksOfTradeInput = {
  projectId: Scalars['ID']['input'];
  tradeKey: Scalars['ID']['input'];
};

export type DeleteAllTasksOfZoneInput = {
  projectId: Scalars['ID']['input'];
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteOrganizationUserRbacInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteProjectUserRbacInput = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DisableProjectUserRbacInput = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type EdgeOrganization = {
  __typename?: 'EdgeOrganization';
  cursor?: Maybe<Scalars['ID']['output']>;
  node: Organization;
};

export type EdgeUser = {
  __typename?: 'EdgeUser';
  cursor?: Maybe<Scalars['ID']['output']>;
  node: User;
};

export type EnableProjectUserRbacInput = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum FieldType {
  Array = 'ARRAY',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  File = 'FILE',
  FixedFile = 'FIXED_FILE',
  FixedPicture = 'FIXED_PICTURE',
  FixedText = 'FIXED_TEXT',
  GridText = 'GRID_TEXT',
  HeaderPicture = 'HEADER_PICTURE',
  Picture = 'PICTURE',
  Radio = 'RADIO',
  Section = 'SECTION',
  Select = 'SELECT',
  SelectEditable = 'SELECT_EDITABLE',
  Signature = 'SIGNATURE',
  Text = 'TEXT',
  Title = 'TITLE'
}

export type File = {
  __typename?: 'File';
  downloadLink?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FileCreateForProjectFileValidationRequestInput = {
  extension: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FileCreateInput = {
  extension: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FileDraft = {
  __typename?: 'FileDraft';
  id: Scalars['ID']['output'];
  uploadLink: Scalars['String']['output'];
};

export type FileFieldInput = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};

export type FileFieldModel = {
  __typename?: 'FileFieldModel';
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  files: Array<File>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
};

export type FileValidateForProjectFileValidationRequestInput = {
  fileId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

export type FileValidateInput = {
  fileId: Scalars['ID']['input'];
};

export type FixedFileFieldInput = {
  id: Scalars['ID']['input'];
  ids: Array<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type FixedFileFieldModel = {
  __typename?: 'FixedFileFieldModel';
  files: Array<File>;
  id: Scalars['String']['output'];
  ids: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  type: FieldType;
};

export type FixedPictureFieldInput = {
  id: Scalars['ID']['input'];
  ids: Array<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type FixedPictureFieldModel = {
  __typename?: 'FixedPictureFieldModel';
  files: Array<File>;
  id: Scalars['String']['output'];
  ids: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  type: FieldType;
};

export type FixedTextFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  requiredValue: Scalars['String']['input'];
};

export type FixedTextFieldModel = {
  __typename?: 'FixedTextFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  requiredValue: Scalars['String']['output'];
  type: FieldType;
};

/** Form model */
export type Form = {
  __typename?: 'Form';
  activities: Array<Activity>;
  author: User;
  comments: Array<Comment>;
  company?: Maybe<Company>;
  createdDate: Scalars['DateTime']['output'];
  formModel: FormModelStructure;
  id: Scalars['ID']['output'];
  idNumber: Scalars['Int']['output'];
  limitDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phase?: Maybe<Phase>;
  projectFile?: Maybe<ProjectFile>;
  projectFilePositions?: Maybe<Array<Maybe<ProjectFilePosition>>>;
  status: FormStatus;
  trade: Trade;
};

export type FormCreateInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  formModelId: Scalars['ID']['input'];
  limitDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phaseKey?: InputMaybe<Scalars['ID']['input']>;
  projectFileId?: InputMaybe<Scalars['ID']['input']>;
  projectFilePositions?: InputMaybe<Array<InputMaybe<ProjectFilePositionCreateInput>>>;
  projectId: Scalars['ID']['input'];
  tradeKey: Scalars['ID']['input'];
};

export type FormDuplicateInput = {
  id: Scalars['ID']['input'];
};

export type FormField = ArrayFieldModel | CheckboxFieldModel | DateFieldModel | FileFieldModel | FixedFileFieldModel | FixedPictureFieldModel | FixedTextFieldModel | GridTextFieldModel | HeaderPictureFieldModel | PictureFieldModel | RadioFieldModel | SectionFieldModel | SelectEditableFieldModel | SelectFieldModel | SignatureFieldModel | TextFieldModel | TitleFieldModel;

export type FormFieldInput = {
  array?: InputMaybe<ArrayFieldInput>;
  checkbox?: InputMaybe<CheckboxFieldInput>;
  date?: InputMaybe<DateFieldInput>;
  file?: InputMaybe<FileFieldInput>;
  fixed_file?: InputMaybe<FixedFileFieldInput>;
  fixed_picture?: InputMaybe<FixedPictureFieldInput>;
  fixed_text?: InputMaybe<FixedTextFieldInput>;
  grid_text?: InputMaybe<GridTextFieldInput>;
  header_picture?: InputMaybe<HeaderPictureFieldInput>;
  picture?: InputMaybe<PictureFieldInput>;
  radio?: InputMaybe<RadioFieldInput>;
  section?: InputMaybe<SectionFieldInput>;
  select?: InputMaybe<SelectFieldInput>;
  select_editable?: InputMaybe<SelectEditableFieldInput>;
  signature?: InputMaybe<SignatureFieldInput>;
  text?: InputMaybe<TextFieldInput>;
  title?: InputMaybe<TitleFieldInput>;
  type: FieldType;
};

/** FormModel model */
export type FormModel = {
  __typename?: 'FormModel';
  author: User;
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isVisible: Scalars['Boolean']['output'];
  structure: FormModelStructure;
  title: Scalars['String']['output'];
};

export type FormModelCreateInput = {
  projectId: Scalars['ID']['input'];
  structure: FormModelStructureInput;
  title: Scalars['String']['input'];
};

export type FormModelDuplicateInput = {
  id: Scalars['ID']['input'];
};

export type FormModelImportInput = {
  formModelIds: Array<Scalars['ID']['input']>;
  targetProjectId: Scalars['ID']['input'];
};

export type FormModelStructure = {
  __typename?: 'FormModelStructure';
  fields: Array<FormField>;
  validationConfig: FormModelValidationConfigModel;
};

export type FormModelStructureInput = {
  fields: Array<FormFieldInput>;
  validationConfig: FormModelValidationConfigInput;
};

export type FormModelUpdateInput = {
  id: Scalars['ID']['input'];
  structure: FormModelStructureInput;
  title: Scalars['String']['input'];
};

export type FormModelUpdateVisibleInput = {
  id: Scalars['ID']['input'];
  isVisible: Scalars['Boolean']['input'];
};

export type FormModelValidationConfigInput = {
  allowAdminEdit: Scalars['Boolean']['input'];
  mode: FormModelValidationMode;
};

export type FormModelValidationConfigModel = {
  __typename?: 'FormModelValidationConfigModel';
  allowAdminEdit: Scalars['Boolean']['output'];
  mode: FormModelValidationMode;
};

export enum FormModelValidationMode {
  OnChange = 'ON_CHANGE',
  Submit = 'SUBMIT'
}

export type FormPositionsUpdateInput = {
  formId: Scalars['ID']['input'];
  positions: ProjectFilePositionCreateInput;
};

export type FormReportInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  formStatus?: InputMaybe<Scalars['String']['input']>;
  limitDate?: InputMaybe<Scalars['String']['input']>;
  ordered: Scalars['Boolean']['input'];
  phaseKey?: InputMaybe<Scalars['String']['input']>;
  pictureSize: Scalars['String']['input'];
  projectFileId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  showCover: Scalars['Boolean']['input'];
  tradeKey?: InputMaybe<Scalars['String']['input']>;
};

export type FormSaveInput = {
  formId: Scalars['ID']['input'];
  formModel: FormModelStructureInput;
};

export enum FormStatus {
  StatusDone = 'STATUS_DONE',
  StatusInProgress = 'STATUS_IN_PROGRESS',
  StatusToDo = 'STATUS_TO_DO'
}

export type FormStatusUpdateInput = {
  formId: Scalars['ID']['input'];
  status: FormStatus;
};

export type FormSubmitInput = {
  formId: Scalars['ID']['input'];
  formModel: FormModelStructureInput;
};

export type FormUpdateInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  formId: Scalars['ID']['input'];
  limitDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phaseKey?: InputMaybe<Scalars['ID']['input']>;
  projectFileId?: InputMaybe<Scalars['ID']['input']>;
  projectFilePositions?: InputMaybe<Array<InputMaybe<ProjectFilePositionCreateInput>>>;
  tradeKey: Scalars['ID']['input'];
};

export enum GrantType {
  Code = 'Code',
  Password = 'Password',
  QrCode = 'QrCode',
  RefreshToken = 'RefreshToken'
}

export type GridRowInput = {
  columns: Array<TextFieldInput>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type GridRowModel = {
  __typename?: 'GridRowModel';
  columns: Array<TextFieldModel>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GridTextFieldInput = {
  id: Scalars['ID']['input'];
  rows: Array<GridRowInput>;
};

export type GridTextFieldModel = {
  __typename?: 'GridTextFieldModel';
  id: Scalars['String']['output'];
  rows: Array<GridRowModel>;
  type: FieldType;
};

export type HeaderPictureFieldInput = {
  fileId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type HeaderPictureFieldModel = {
  __typename?: 'HeaderPictureFieldModel';
  file: File;
  fileId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: FieldType;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type MeUpdateInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type MoveAllTasksFromCompanyInput = {
  fromCompanyId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  toCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveAllTasksFromTradeInput = {
  fromTradeKey: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  toTradeKey: Scalars['ID']['input'];
};

export type MoveAllTasksFromZoneInput = {
  fromZoneId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  toZoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminStartSubscription: Subscription;
  adminStopSubscription: Subscription;
  cancelProjectFileValidationRequest: Scalars['Boolean']['output'];
  configureOrganizationUserRBAC: Scalars['Boolean']['output'];
  configureProjectUserRBAC: ProjectUserRbac;
  createComment: Comment;
  createCommentForProjectFileValidationRequest: Comment;
  createCompany: Company;
  createFileDraft: FileDraft;
  createFileDraftForProjectFileValidationRequest: FileDraft;
  createForm: Form;
  createFormModel: FormModel;
  createObservation: Observation;
  createOrganization: Organization;
  createProject: Project;
  createProjectFile: ProjectFile;
  createProjectFileValidationRequest: ProjectFileValidationRequest;
  createProjectFolder: ProjectFolder;
  createSequenceTemplate: SequenceTemplate;
  createTaskTemplate: TaskTemplate;
  createTasks: Scalars['Boolean']['output'];
  createUser: User;
  createZone: Zone;
  deleteAllTasksOfCompany: Scalars['Boolean']['output'];
  deleteAllTasksOfTrade: Scalars['Boolean']['output'];
  deleteAllTasksOfZone: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteForm: Scalars['Boolean']['output'];
  deleteFormModel: Scalars['Boolean']['output'];
  deleteObservation: Scalars['Boolean']['output'];
  deleteOrganizationUserRBAC: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteProjectFile: Scalars['Boolean']['output'];
  deleteProjectFolder: Scalars['Boolean']['output'];
  deleteProjectUserRBAC: Scalars['Boolean']['output'];
  deleteSequenceTemplate: Scalars['Boolean']['output'];
  deleteTask: Scalars['Boolean']['output'];
  deleteTaskTemplate: Scalars['Boolean']['output'];
  deleteTasks: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  deleteZone: Scalars['Boolean']['output'];
  disableProjectUserRBAC: Scalars['Boolean']['output'];
  duplicateForm: Form;
  duplicateFormModel: FormModel;
  duplicateProjectFolder: Scalars['Boolean']['output'];
  duplicateZone: Zone;
  enableProjectUserRBAC: Scalars['Boolean']['output'];
  ignoreProjectFileValidationRequestByToken: Scalars['Boolean']['output'];
  importFormModels: Scalars['Boolean']['output'];
  inviteUserToProject: Scalars['Boolean']['output'];
  moveAllTasksFromCompanyToAnother: Scalars['Boolean']['output'];
  moveAllTasksFromTradeToAnother: Scalars['Boolean']['output'];
  moveAllTasksFromZoneToAnother: Scalars['Boolean']['output'];
  observationSetTask: Scalars['Boolean']['output'];
  observationUnsetTask: Scalars['Boolean']['output'];
  projectFileSetZone: Scalars['Boolean']['output'];
  projectFileUnsetZone: Scalars['Boolean']['output'];
  refuseProjectFileValidationRequest: Scalars['Boolean']['output'];
  refuseProjectFileValidationRequestByToken: Scalars['Boolean']['output'];
  registerProjectSharing: Scalars['String']['output'];
  saveForm: Form;
  sendAuthCode: Scalars['Boolean']['output'];
  sendFormsReport: Scalars['Boolean']['output'];
  sendObservationsReport: Scalars['Boolean']['output'];
  sendPlanningReport: Scalars['Boolean']['output'];
  setProjectEmailSettings: Scalars['Boolean']['output'];
  setProjectFolderRoles: ProjectFolder;
  signIn: AuthPayload;
  signOut: Scalars['Boolean']['output'];
  signUp: AuthPayload;
  sortCompanys: Array<Company>;
  sortSequenceTemplates: Array<SequenceTemplate>;
  sortTaskTemplates: Array<TaskTemplate>;
  sortZones: Array<Zone>;
  startSubscription: Subscription;
  stopSubscription: Subscription;
  submitForm: Form;
  updateCompany: Company;
  updateForm: Form;
  updateFormModel: FormModel;
  updateFormModelVisible: Scalars['Boolean']['output'];
  updateFormPositions: Form;
  updateFormStatus: Form;
  updateLocale: Scalars['Boolean']['output'];
  updateMe: User;
  updateObservation: Observation;
  updateObservationPositions: Observation;
  updateObservationStatus: Observation;
  updateOrganization: Organization;
  updateProject: Project;
  updateProjectFile: ProjectFile;
  updateProjectFileAnnotations: Scalars['Boolean']['output'];
  updateProjectFileStatus: ProjectFile;
  updateProjectFolder: ProjectFolder;
  updateSequenceTemplate: SequenceTemplate;
  updateStartDateOfCompany: Scalars['Boolean']['output'];
  updateStartDateOfTrade: Scalars['Boolean']['output'];
  updateStartDateOfZone: Scalars['Boolean']['output'];
  updateStartRowOfCompanyAndTrade: Scalars['Boolean']['output'];
  updateTask: Task;
  updateTaskColor: Scalars['Boolean']['output'];
  updateTaskPositions: Task;
  updateTaskProgress: Task;
  updateTaskStatus: Task;
  updateTaskTemplate: TaskTemplate;
  updateTasks: Scalars['Boolean']['output'];
  updateUser: User;
  updateZone: Zone;
  validProjectFileValidationRequest: Scalars['Boolean']['output'];
  validProjectFileValidationRequestByToken: Scalars['Boolean']['output'];
  validWithObservationProjectFileValidationRequestByToken: Scalars['Boolean']['output'];
  validateFile: Scalars['Boolean']['output'];
  validateFileForProjectFileValidationRequest: Scalars['Boolean']['output'];
};


export type MutationAdminStartSubscriptionArgs = {
  input: SubscriptionStartInput;
};


export type MutationAdminStopSubscriptionArgs = {
  input: SubscriptionStopInput;
};


export type MutationCancelProjectFileValidationRequestArgs = {
  input: ProjectFileValidationRequestCancelInput;
};


export type MutationConfigureOrganizationUserRbacArgs = {
  input: ConfigureOrganizationUserRbacInput;
};


export type MutationConfigureProjectUserRbacArgs = {
  input: ConfigureProjectUserRbacInput;
};


export type MutationCreateCommentArgs = {
  input: CommentCreateInput;
};


export type MutationCreateCommentForProjectFileValidationRequestArgs = {
  input: CommentCreateForProjectFileValidationRequestInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyCreateInput;
};


export type MutationCreateFileDraftArgs = {
  input: FileCreateInput;
};


export type MutationCreateFileDraftForProjectFileValidationRequestArgs = {
  input: FileCreateForProjectFileValidationRequestInput;
};


export type MutationCreateFormArgs = {
  input: FormCreateInput;
};


export type MutationCreateFormModelArgs = {
  input: FormModelCreateInput;
};


export type MutationCreateObservationArgs = {
  input: ObservationCreateInput;
};


export type MutationCreateOrganizationArgs = {
  input: OrganizationCreateInput;
};


export type MutationCreateProjectArgs = {
  input: ProjectCreateInput;
};


export type MutationCreateProjectFileArgs = {
  input: ProjectFileCreateInput;
};


export type MutationCreateProjectFileValidationRequestArgs = {
  input: ProjectFileValidationRequestCreateInput;
};


export type MutationCreateProjectFolderArgs = {
  input: ProjectFolderCreateInput;
};


export type MutationCreateSequenceTemplateArgs = {
  input: SequenceTemplateCreateInput;
};


export type MutationCreateTaskTemplateArgs = {
  input: TaskTemplateCreateInput;
};


export type MutationCreateTasksArgs = {
  input: TasksCreateInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateZoneArgs = {
  input: ZoneCreateInput;
};


export type MutationDeleteAllTasksOfCompanyArgs = {
  input: DeleteAllTasksOfCompanyInput;
};


export type MutationDeleteAllTasksOfTradeArgs = {
  input: DeleteAllTasksOfTradeInput;
};


export type MutationDeleteAllTasksOfZoneArgs = {
  input: DeleteAllTasksOfZoneInput;
};


export type MutationDeleteCommentArgs = {
  input: CommentDeleteInput;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteObservationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationUserRbacArgs = {
  input: DeleteOrganizationUserRbacInput;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectFileArgs = {
  input: ProjectFileDeleteInput;
};


export type MutationDeleteProjectFolderArgs = {
  input: ProjectFolderDeleteInput;
};


export type MutationDeleteProjectUserRbacArgs = {
  input: DeleteProjectUserRbacInput;
};


export type MutationDeleteSequenceTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteZoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableProjectUserRbacArgs = {
  input: DisableProjectUserRbacInput;
};


export type MutationDuplicateFormArgs = {
  input: FormDuplicateInput;
};


export type MutationDuplicateFormModelArgs = {
  input: FormModelDuplicateInput;
};


export type MutationDuplicateProjectFolderArgs = {
  input: ProjectFolderDuplicateInput;
};


export type MutationDuplicateZoneArgs = {
  input: ZoneDuplicateInput;
};


export type MutationEnableProjectUserRbacArgs = {
  input: EnableProjectUserRbacInput;
};


export type MutationIgnoreProjectFileValidationRequestByTokenArgs = {
  input: ProjectFileValidationRequestIgnoreByTokenInput;
};


export type MutationImportFormModelsArgs = {
  input: FormModelImportInput;
};


export type MutationInviteUserToProjectArgs = {
  input: UserInviteToProjectInput;
};


export type MutationMoveAllTasksFromCompanyToAnotherArgs = {
  input: MoveAllTasksFromCompanyInput;
};


export type MutationMoveAllTasksFromTradeToAnotherArgs = {
  input: MoveAllTasksFromTradeInput;
};


export type MutationMoveAllTasksFromZoneToAnotherArgs = {
  input: MoveAllTasksFromZoneInput;
};


export type MutationObservationSetTaskArgs = {
  input: ObservationSetTaskInput;
};


export type MutationObservationUnsetTaskArgs = {
  input: ObservationUnsetTaskInput;
};


export type MutationProjectFileSetZoneArgs = {
  input: ProjectFileSetZoneInput;
};


export type MutationProjectFileUnsetZoneArgs = {
  input: ProjectFileUnsetZoneInput;
};


export type MutationRefuseProjectFileValidationRequestArgs = {
  input: ProjectFileValidationRequestRefuseInput;
};


export type MutationRefuseProjectFileValidationRequestByTokenArgs = {
  input: ProjectFileValidationRequestRefuseByTokenInput;
};


export type MutationRegisterProjectSharingArgs = {
  input: ProjectSharingRegisterInput;
};


export type MutationSaveFormArgs = {
  input: FormSaveInput;
};


export type MutationSendAuthCodeArgs = {
  input: UserSendAuthCodeInput;
};


export type MutationSendFormsReportArgs = {
  input: FormReportInput;
};


export type MutationSendObservationsReportArgs = {
  input: ObservationReportInput;
};


export type MutationSendPlanningReportArgs = {
  input: PlanningReportInput;
};


export type MutationSetProjectEmailSettingsArgs = {
  input: ProjectEmailSetSettingsInput;
};


export type MutationSetProjectFolderRolesArgs = {
  input: ProjectFolderSetRolesInput;
};


export type MutationSignInArgs = {
  input: UserSignInInput;
};


export type MutationSignOutArgs = {
  input: UserSignOutInput;
};


export type MutationSignUpArgs = {
  input: UserRegisterInput;
};


export type MutationSortCompanysArgs = {
  input: CompanysSortInput;
};


export type MutationSortSequenceTemplatesArgs = {
  input: SequenceTemplatesSortInput;
};


export type MutationSortTaskTemplatesArgs = {
  input: TaskTemplatesSortInput;
};


export type MutationSortZonesArgs = {
  input: ZonesSortInput;
};


export type MutationStartSubscriptionArgs = {
  input: SubscriptionStartInput;
};


export type MutationStopSubscriptionArgs = {
  input: SubscriptionStopInput;
};


export type MutationSubmitFormArgs = {
  input: FormSubmitInput;
};


export type MutationUpdateCompanyArgs = {
  input: CompanyUpdateInput;
};


export type MutationUpdateFormArgs = {
  input: FormUpdateInput;
};


export type MutationUpdateFormModelArgs = {
  input: FormModelUpdateInput;
};


export type MutationUpdateFormModelVisibleArgs = {
  input: FormModelUpdateVisibleInput;
};


export type MutationUpdateFormPositionsArgs = {
  input: FormPositionsUpdateInput;
};


export type MutationUpdateFormStatusArgs = {
  input: FormStatusUpdateInput;
};


export type MutationUpdateLocaleArgs = {
  input: UpdateLocaleInput;
};


export type MutationUpdateMeArgs = {
  input: MeUpdateInput;
};


export type MutationUpdateObservationArgs = {
  input: ObservationUpdateInput;
};


export type MutationUpdateObservationPositionsArgs = {
  input: ObservationPositionsUpdateInput;
};


export type MutationUpdateObservationStatusArgs = {
  input: ObservationStatusUpdateInput;
};


export type MutationUpdateOrganizationArgs = {
  input: OrganizationUpdateInput;
};


export type MutationUpdateProjectArgs = {
  input: ProjectUpdateInput;
};


export type MutationUpdateProjectFileArgs = {
  input: ProjectFileUpdateInput;
};


export type MutationUpdateProjectFileAnnotationsArgs = {
  input: ProjectFileUpdateAnnotationsInput;
};


export type MutationUpdateProjectFileStatusArgs = {
  input: ProjectFileStatusUpdateInput;
};


export type MutationUpdateProjectFolderArgs = {
  input: ProjectFolderUpdateInput;
};


export type MutationUpdateSequenceTemplateArgs = {
  input: SequenceTemplateUpdateInput;
};


export type MutationUpdateStartDateOfCompanyArgs = {
  input: UpdateStartDateOfCompanyInput;
};


export type MutationUpdateStartDateOfTradeArgs = {
  input: UpdateStartDateOfTradeInput;
};


export type MutationUpdateStartDateOfZoneArgs = {
  input: UpdateStartDateOfZoneInput;
};


export type MutationUpdateTaskArgs = {
  input: TaskUpdateInput;
};


export type MutationUpdateTaskColorArgs = {
  input: TaskColorUpdateInput;
};


export type MutationUpdateTaskPositionsArgs = {
  input: TaskPositionsUpdateInput;
};


export type MutationUpdateTaskProgressArgs = {
  input: TaskProgressUpdateInput;
};


export type MutationUpdateTaskStatusArgs = {
  input: TaskStatusUpdateInput;
};


export type MutationUpdateTaskTemplateArgs = {
  input: TaskTemplateUpdateInput;
};


export type MutationUpdateTasksArgs = {
  input: TasksUpdateInput;
};


export type MutationUpdateUserArgs = {
  input: UserUpdateInput;
};


export type MutationUpdateZoneArgs = {
  input: ZoneUpdateInput;
};


export type MutationValidProjectFileValidationRequestArgs = {
  input: ProjectFileValidationRequestValidInput;
};


export type MutationValidProjectFileValidationRequestByTokenArgs = {
  input: ProjectFileValidationRequestValidByTokenInput;
};


export type MutationValidWithObservationProjectFileValidationRequestByTokenArgs = {
  input: ProjectFileValidationRequestValidWithObservationByTokenInput;
};


export type MutationValidateFileArgs = {
  input: FileValidateInput;
};


export type MutationValidateFileForProjectFileValidationRequestArgs = {
  input: FileValidateForProjectFileValidationRequestInput;
};

/** Observation model */
export type Observation = {
  __typename?: 'Observation';
  activities: Array<Activity>;
  author: User;
  comments: Array<Comment>;
  company?: Maybe<Company>;
  createdDate: Scalars['DateTime']['output'];
  files: Array<File>;
  id: Scalars['ID']['output'];
  idNumber: Scalars['Int']['output'];
  limitDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phase?: Maybe<Phase>;
  projectFile?: Maybe<ProjectFile>;
  projectFilePositions?: Maybe<Array<Maybe<ProjectFilePosition>>>;
  projectId: Scalars['ID']['output'];
  status: ObservationStatus;
  task?: Maybe<Task>;
  trade: Trade;
};

export type ObservationCreateInput = {
  observation: ObservationInput;
  projectId: Scalars['ID']['input'];
};

export type ObservationInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limitDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  phaseKey?: InputMaybe<Scalars['ID']['input']>;
  projectFileId?: InputMaybe<Scalars['ID']['input']>;
  projectFilePositions?: InputMaybe<Array<InputMaybe<ProjectFilePositionCreateInput>>>;
  tradeKey: Scalars['ID']['input'];
};

export type ObservationPositionsUpdateInput = {
  observationId: Scalars['ID']['input'];
  positions: ProjectFilePositionCreateInput;
};

export type ObservationReportInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdDate?: InputMaybe<Scalars['String']['input']>;
  limitDate?: InputMaybe<Scalars['String']['input']>;
  observationStatus?: InputMaybe<Scalars['String']['input']>;
  ordered: Scalars['Boolean']['input'];
  phaseKey?: InputMaybe<Scalars['String']['input']>;
  pictureSize: Scalars['String']['input'];
  projectFileId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  showCover: Scalars['Boolean']['input'];
  tradeKey?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationSetTaskInput = {
  observationId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};

export enum ObservationStatus {
  StatusContested = 'STATUS_CONTESTED',
  StatusPlannedRecovery = 'STATUS_PLANNED_RECOVERY',
  StatusToDo = 'STATUS_TO_DO',
  StatusValidatedByAdmin = 'STATUS_VALIDATED_BY_ADMIN',
  StatusValidatedByCustomer = 'STATUS_VALIDATED_BY_CUSTOMER',
  StatusValidatedByReader = 'STATUS_VALIDATED_BY_READER'
}

export type ObservationStatusUpdateInput = {
  observationId: Scalars['ID']['input'];
  status: ObservationStatus;
};

export type ObservationUnsetTaskInput = {
  observationId: Scalars['ID']['input'];
};

export type ObservationUpdateInput = {
  observation: ObservationInput;
  observationId: Scalars['ID']['input'];
};

export type OptionInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  redirectTo?: InputMaybe<Scalars['String']['input']>;
};

export type OptionModel = {
  __typename?: 'OptionModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  redirectTo?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type OrganizationCreateInput = {
  name: Scalars['String']['input'];
};

export type OrganizationFindInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationRole {
  RoleOrganizationAdmin = 'ROLE_ORGANIZATION_ADMIN',
  RoleOrganizationOwner = 'ROLE_ORGANIZATION_OWNER',
  RoleOrganizationUser = 'ROLE_ORGANIZATION_USER'
}

export type OrganizationUpdateInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type OrganizationUserRbac = {
  __typename?: 'OrganizationUserRBAC';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  role: OrganizationRole;
  updatedDate: Scalars['DateTime']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type PaginatedOrganization = {
  __typename?: 'PaginatedOrganization';
  edges: Array<EdgeOrganization>;
  pageInfo: PageInfo;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  edges: Array<EdgeUser>;
  pageInfo: PageInfo;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Float']['input'];
};

export enum PaymentMethodRedirectPath {
  PaymentMethod = 'PAYMENT_METHOD',
  Subscription = 'SUBSCRIPTION'
}

export type Phase = {
  __typename?: 'Phase';
  color?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
};

export type PictureFieldInput = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};

export type PictureFieldModel = {
  __typename?: 'PictureFieldModel';
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  files: Array<File>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
};

export type Planning = {
  __typename?: 'Planning';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tasks: Array<Task>;
  updatedDate: Scalars['DateTime']['output'];
};

export type PlanningFindInput = {
  projectId: Scalars['ID']['input'];
};

export type PlanningReportInput = {
  endDate: Scalars['DateTime']['input'];
  planningFileId: Scalars['String']['input'];
  planningType: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  showCover: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type Project = {
  __typename?: 'Project';
  allUserACL: Array<ProjectUserRbac>;
  author: User;
  authorId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  contacts?: Maybe<Array<ProjectContact>>;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  documentFolders: Array<ProjectFolder>;
  documents: Array<ProjectFile>;
  formModels: Array<FormModel>;
  id: Scalars['ID']['output'];
  isTrialPeriodExpired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  observations: Array<Observation>;
  photos: Array<ProjectFile>;
  planFolders: Array<ProjectFolder>;
  plans: Array<ProjectFile>;
  sequenceTemplates: Array<SequenceTemplate>;
  subscription?: Maybe<Subscription>;
  trialPeriodEndDate: Scalars['DateTime']['output'];
  trialPeriodStartDate: Scalars['DateTime']['output'];
  updatedDate: Scalars['DateTime']['output'];
  userACL: Array<ProjectUserRbac>;
};

export type ProjectContact = {
  __typename?: 'ProjectContact';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Float']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ProjectContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCreateInput = {
  companyName: Scalars['String']['input'];
  contacts?: InputMaybe<Array<ProjectContactInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ProjectEmailSetSettingsInput = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  subjectPrefix?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectEmailSettings = {
  __typename?: 'ProjectEmailSettings';
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  subjectPrefix?: Maybe<Scalars['String']['output']>;
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  activities: Array<Activity>;
  author: User;
  comments: Array<Comment>;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file: File;
  folderId?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  observations: Array<Observation>;
  status?: Maybe<ProjectFileStatus>;
  tasks: Array<Task>;
  type: ProjectFileType;
  updatedDate: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  validationRequest?: Maybe<ProjectFileValidationRequest>;
  xfdf?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type ProjectFileCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  type: ProjectFileType;
  xfdf?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectFileDeleteInput = {
  projectFileId: Scalars['ID']['input'];
};

export type ProjectFilePosition = {
  __typename?: 'ProjectFilePosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ProjectFilePositionCreateInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type ProjectFileSetZoneInput = {
  projectFileId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export enum ProjectFileStatus {
  Pending = 'PENDING',
  Refused = 'REFUSED',
  Validated = 'VALIDATED',
  ValidatedWithObservation = 'VALIDATED_WITH_OBSERVATION'
}

export type ProjectFileStatusUpdateInput = {
  projectFileId: Scalars['ID']['input'];
  status?: InputMaybe<ProjectFileStatus>;
};

export enum ProjectFileType {
  TypeDocument = 'TYPE_DOCUMENT',
  TypePhoto = 'TYPE_PHOTO',
  TypePlan = 'TYPE_PLAN'
}

export type ProjectFileUnsetZoneInput = {
  projectFileId: Scalars['ID']['input'];
};

export type ProjectFileUpdateAnnotationsInput = {
  projectFileId: Scalars['ID']['input'];
  xfdf: Scalars['String']['input'];
};

export type ProjectFileUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  projectFileId: Scalars['ID']['input'];
};

export type ProjectFileValidationRequest = {
  __typename?: 'ProjectFileValidationRequest';
  author: User;
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: ProjectFileStatus;
  updatedDate: Scalars['DateTime']['output'];
  validationUsers: Array<ProjectFileValidationUser>;
};

export type ProjectFileValidationRequestByToken = {
  __typename?: 'ProjectFileValidationRequestByToken';
  activities: Array<Activity>;
  authorUsername: Scalars['String']['output'];
  comments: Array<Comment>;
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ProjectFileValidationRequestCancelInput = {
  projectFileId: Scalars['ID']['input'];
};

export type ProjectFileValidationRequestCreateInput = {
  projectFileId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type ProjectFileValidationRequestIgnoreByTokenInput = {
  token: Scalars['String']['input'];
};

export type ProjectFileValidationRequestRefuseByTokenInput = {
  token: Scalars['String']['input'];
};

export type ProjectFileValidationRequestRefuseInput = {
  projectFileValidationRequestId: Scalars['ID']['input'];
};

export type ProjectFileValidationRequestValidByTokenInput = {
  token: Scalars['String']['input'];
};

export type ProjectFileValidationRequestValidInput = {
  projectFileValidationRequestId: Scalars['ID']['input'];
};

export type ProjectFileValidationRequestValidWithObservationByTokenInput = {
  token: Scalars['String']['input'];
};

export type ProjectFileValidationUser = {
  __typename?: 'ProjectFileValidationUser';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: ProjectFileStatus;
  updatedDate: Scalars['DateTime']['output'];
  user: User;
};

export type ProjectFolder = {
  __typename?: 'ProjectFolder';
  author: User;
  authorizedRole?: Maybe<ProjectFolderRole>;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReadableByRoleProjectQRCode: Scalars['Boolean']['output'];
  loggedUserRole?: Maybe<ProjectFolderRole>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  type: ProjectFileType;
  updatedDate: Scalars['DateTime']['output'];
};

export type ProjectFolderAuthorizedUserInput = {
  role: ProjectFolderRole;
  userId: Scalars['String']['input'];
};

export type ProjectFolderCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  type: ProjectFileType;
};

export type ProjectFolderDeleteInput = {
  projectFolderId: Scalars['ID']['input'];
};

export type ProjectFolderDuplicateInput = {
  projectFolderId: Scalars['ID']['input'];
};

export enum ProjectFolderRole {
  RoleProjectFolderEdit = 'ROLE_PROJECT_FOLDER_EDIT',
  RoleProjectFolderRead = 'ROLE_PROJECT_FOLDER_READ'
}

export type ProjectFolderSetRolesInput = {
  authorizedRole?: InputMaybe<ProjectFolderRole>;
  authorizedUsers?: InputMaybe<Array<ProjectFolderAuthorizedUserInput>>;
  isReadableByRoleProjectQRCode: Scalars['Boolean']['input'];
  projectFolderId: Scalars['ID']['input'];
};

export type ProjectFolderUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectFolderId: Scalars['ID']['input'];
};

export type ProjectFolderUserRbac = {
  __typename?: 'ProjectFolderUserRBAC';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  projectFolderId: Scalars['ID']['output'];
  role: ProjectFolderRole;
  updatedDate: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum ProjectRole {
  RoleProjectAdmin = 'ROLE_PROJECT_ADMIN',
  RoleProjectCustomer = 'ROLE_PROJECT_CUSTOMER',
  RoleProjectQrCode = 'ROLE_PROJECT_QR_CODE',
  RoleProjectReader = 'ROLE_PROJECT_READER'
}

export type ProjectSharingRegisterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  projectSharingId: Scalars['ID']['input'];
};

export type ProjectUpdateInput = {
  companyName: Scalars['String']['input'];
  contacts?: InputMaybe<Array<ProjectContactInput>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ProjectUserRbac = {
  __typename?: 'ProjectUserRBAC';
  company?: Maybe<Company>;
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  project: Project;
  role: ProjectRole;
  updatedDate: Scalars['DateTime']['output'];
  user: User;
};

export type ProjectsFindInput = {
  organizationId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminFindProjects: Array<Project>;
  availableFormModels: Array<FormModel>;
  company: Company;
  companys: Array<Company>;
  customer?: Maybe<Customer>;
  findActivities: Array<Activity>;
  findComments: Array<Comment>;
  findPlanning: Planning;
  form: Form;
  formModel: FormModel;
  formModels: Array<FormModel>;
  forms: Array<Form>;
  getUserAccessToken: Scalars['String']['output'];
  invoices: Array<Invoice>;
  isEmailAvailable: Scalars['Boolean']['output'];
  me: User;
  observation: Observation;
  observations: Array<Observation>;
  organizations: PaginatedOrganization;
  phases: Array<Phase>;
  project: Project;
  projectEmailSettings: ProjectEmailSettings;
  projectFile: ProjectFile;
  projectFileValidationRequestByToken: ProjectFileValidationRequestByToken;
  projectFolder: ProjectFolder;
  projectFolderUserACL: Array<ProjectFolderUserRbac>;
  projects: Array<Project>;
  requestCustomerDashboardLink: Scalars['String']['output'];
  requestPaymentMethodRegisterLink: Scalars['String']['output'];
  requestProjectSharingLink: Scalars['String']['output'];
  sequenceLibraries: Array<SequenceLibrary>;
  sequenceLibrary: SequenceLibrary;
  sequenceTemplate: SequenceTemplate;
  sequenceTemplates: Array<SequenceTemplate>;
  sharedProjects: Array<Project>;
  task: Task;
  taskLibraries: Array<TaskLibrary>;
  taskLibrary: TaskLibrary;
  taskTemplate: TaskTemplate;
  taskTemplates: Array<TaskTemplate>;
  trades: Array<Trade>;
  user: User;
  users: PaginatedUser;
  zone: Zone;
  zoning: Array<Zone>;
};


export type QueryAvailableFormModelsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanysArgs = {
  input: CompanysFindInput;
};


export type QueryFindActivitiesArgs = {
  input: ActivityFindInput;
};


export type QueryFindCommentsArgs = {
  input: CommentFindInput;
};


export type QueryFindPlanningArgs = {
  input: PlanningFindInput;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormModelsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryFormsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetUserAccessTokenArgs = {
  input: UserGetAccessTokenInput;
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


export type QueryObservationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryObservationsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  input?: InputMaybe<OrganizationFindInput>;
  pagination: PaginationInput;
};


export type QueryPhasesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectEmailSettingsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectFileValidationRequestByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryProjectFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectFolderUserAclArgs = {
  projectFolderId: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  input: ProjectsFindInput;
};


export type QueryRequestPaymentMethodRegisterLinkArgs = {
  input: RequestPaymentMethodRegisterLinkInput;
};


export type QueryRequestProjectSharingLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySequenceLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySequenceTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySequenceTemplatesArgs = {
  input: SequenceTemplatesFindInput;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskTemplatesArgs = {
  input: TaskTemplatesFindInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserFindInput>;
  pagination: PaginationInput;
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZoningArgs = {
  input: ZoningFindInput;
};

export type RadioFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options: Array<OptionInput>;
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RadioFieldModel = {
  __typename?: 'RadioFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<OptionModel>;
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type RequestPaymentMethodRegisterLinkInput = {
  redirectPath?: InputMaybe<PaymentMethodRedirectPath>;
};

export type SectionFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type SectionFieldModel = {
  __typename?: 'SectionFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: FieldType;
};

export type SelectEditableFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options: Array<OptionInput>;
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SelectEditableFieldModel = {
  __typename?: 'SelectEditableFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<OptionModel>;
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type SelectFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  options: Array<OptionInput>;
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SelectFieldModel = {
  __typename?: 'SelectFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<OptionModel>;
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type SequenceLibrary = {
  __typename?: 'SequenceLibrary';
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tasks: Array<SequenceTaskLibrary>;
  updatedDate: Scalars['DateTime']['output'];
};

export type SequenceTaskLibrary = {
  __typename?: 'SequenceTaskLibrary';
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDay: Scalars['Float']['output'];
  startRow: Scalars['Float']['output'];
  taskId: Scalars['ID']['output'];
  trade: Trade;
  workforce: Scalars['Float']['output'];
};

export type SequenceTaskTemplate = {
  __typename?: 'SequenceTaskTemplate';
  company?: Maybe<Company>;
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDay: Scalars['Float']['output'];
  startRow: Scalars['Float']['output'];
  taskId: Scalars['ID']['output'];
  trade: Trade;
  workforce: Scalars['Float']['output'];
};

export type SequenceTaskTemplateInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  startDay: Scalars['Float']['input'];
  startRow: Scalars['Float']['input'];
  tradeKey: Scalars['ID']['input'];
  workforce: Scalars['Float']['input'];
};

export type SequenceTemplate = {
  __typename?: 'SequenceTemplate';
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  tasks: Array<SequenceTaskTemplate>;
  updatedDate: Scalars['DateTime']['output'];
};

export type SequenceTemplateCreateInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  tasks: Array<SequenceTaskTemplateInput>;
};

export type SequenceTemplateUpdateInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  tasks: Array<SequenceTaskTemplateInput>;
};

export type SequenceTemplatesFindInput = {
  projectId: Scalars['ID']['input'];
};

export type SequenceTemplatesSortInput = {
  projectId: Scalars['ID']['input'];
  sequencesData: Array<SortedSequenceTemplateData>;
};

export type SignatureFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SignatureFieldModel = {
  __typename?: 'SignatureFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type SortedCompanyData = {
  id: Scalars['ID']['input'];
  index: Scalars['Float']['input'];
};

export type SortedSequenceTemplateData = {
  id: Scalars['ID']['input'];
  index: Scalars['Float']['input'];
};

export type SortedTaskTemplateData = {
  id: Scalars['ID']['input'];
  index: Scalars['Float']['input'];
};

export type SortedZoneData = {
  id: Scalars['ID']['input'];
  index: Scalars['Float']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  amount: Scalars['Float']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  provider: SubscriptionProvider;
  status: SubscriptionStatus;
  updatedDate: Scalars['DateTime']['output'];
};

export enum SubscriptionProvider {
  Stripe = 'STRIPE',
  Toolkit = 'TOOLKIT'
}

export type SubscriptionStartInput = {
  projectId: Scalars['ID']['input'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED'
}

export type SubscriptionStopInput = {
  projectId: Scalars['ID']['input'];
};

/** Task model */
export type Task = {
  __typename?: 'Task';
  activities: Array<Activity>;
  color?: Maybe<Scalars['String']['output']>;
  comments: Array<Comment>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  endAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  idNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  observation?: Maybe<Observation>;
  progress: Scalars['Int']['output'];
  projectFile?: Maybe<ProjectFile>;
  projectFileId?: Maybe<Scalars['ID']['output']>;
  projectFilePositions?: Maybe<Array<Maybe<ProjectFilePosition>>>;
  requiredDuration: Scalars['Float']['output'];
  startAt: Scalars['DateTime']['output'];
  startRowByCompany: Scalars['Float']['output'];
  startRowByTrade: Scalars['Float']['output'];
  startRowByZone: Scalars['Float']['output'];
  status: TaskStatus;
  trade: Trade;
  tradeKey: Scalars['ID']['output'];
  workforce: Scalars['Float']['output'];
  zone?: Maybe<Zone>;
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type TaskColorUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type TaskInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  projectFileId?: InputMaybe<Scalars['ID']['input']>;
  projectFilePositions?: InputMaybe<Array<InputMaybe<ProjectFilePositionCreateInput>>>;
  requiredDuration: Scalars['Float']['input'];
  startAt: Scalars['DateTime']['input'];
  startRowByCompany?: InputMaybe<Scalars['Float']['input']>;
  startRowByTrade?: InputMaybe<Scalars['Float']['input']>;
  startRowByZone?: InputMaybe<Scalars['Float']['input']>;
  tradeKey: Scalars['ID']['input'];
  workforce: Scalars['Float']['input'];
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskLibrary = {
  __typename?: 'TaskLibrary';
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  trade?: Maybe<Trade>;
  updatedDate: Scalars['DateTime']['output'];
  workforce?: Maybe<Scalars['Float']['output']>;
};

export type TaskPositionsUpdateInput = {
  positions: ProjectFilePositionCreateInput;
  taskId: Scalars['ID']['input'];
};

export type TaskProgressUpdateInput = {
  progress: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
};

export enum TaskStatus {
  StatusDone = 'STATUS_DONE',
  StatusInProgress = 'STATUS_IN_PROGRESS',
  StatusToDo = 'STATUS_TO_DO',
  StatusWarning = 'STATUS_WARNING'
}

export type TaskStatusUpdateInput = {
  status: TaskStatus;
  taskId: Scalars['ID']['input'];
};

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  company?: Maybe<Company>;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  trade: Trade;
  updatedDate: Scalars['DateTime']['output'];
  workforce: Scalars['Float']['output'];
};

export type TaskTemplateCreateInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  duration: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  tradeKey: Scalars['ID']['input'];
  workforce: Scalars['Float']['input'];
};

export type TaskTemplateUpdateInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  duration: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  tradeKey: Scalars['ID']['input'];
  workforce: Scalars['Float']['input'];
};

export type TaskTemplatesFindInput = {
  projectId: Scalars['ID']['input'];
};

export type TaskTemplatesSortInput = {
  projectId: Scalars['ID']['input'];
  tasksData: Array<SortedTaskTemplateData>;
};

export type TaskUpdateInput = {
  task: TaskInput;
  taskId: Scalars['ID']['input'];
};

export type TasksCreateInput = {
  projectId: Scalars['ID']['input'];
  tasks: Array<TaskInput>;
};

export type TasksUpdateInput = {
  tasks: Array<TaskUpdateInput>;
};

export type TextFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TextFieldModel = {
  __typename?: 'TextFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type TitleFieldInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type TitleFieldModel = {
  __typename?: 'TitleFieldModel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: FieldType;
};

export type Trade = {
  __typename?: 'Trade';
  color?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
};

export type UpdateLocaleInput = {
  locale: Scalars['String']['input'];
};

export type UpdateStartDateOfCompanyInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UpdateStartDateOfTradeInput = {
  projectId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  tradeKey: Scalars['ID']['input'];
};

export type UpdateStartDateOfZoneInput = {
  projectId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  __typename?: 'User';
  createdDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  organizationACL: Array<OrganizationUserRbac>;
  projectACL: Array<ProjectUserRbac>;
  role: UserRole;
  updatedDate: Scalars['DateTime']['output'];
};

export type UserCreateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UserFindInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type UserGetAccessTokenInput = {
  userId: Scalars['String']['input'];
};

export type UserInviteToProjectInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  role?: InputMaybe<ProjectRole>;
};

export type UserRegisterInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  RoleAdmin = 'ROLE_ADMIN',
  RolePublic = 'ROLE_PUBLIC',
  RoleUser = 'ROLE_USER'
}

export type UserSendAuthCodeInput = {
  email: Scalars['String']['input'];
};

export type UserSignInInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  grantType: GrantType;
  password?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserSignOutInput = {
  refreshToken: Scalars['String']['input'];
};

export type UserUpdateInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
};

export type Zone = {
  __typename?: 'Zone';
  children: Array<Zone>;
  createdDate: Scalars['DateTime']['output'];
  deletedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Zone>;
  parentId?: Maybe<Scalars['ID']['output']>;
  plans: Array<ProjectFile>;
  type: ZoneType;
  updatedDate: Scalars['DateTime']['output'];
};

export type ZoneCreateInput = {
  description: Scalars['String']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
  type: ZoneType;
};

export type ZoneDuplicateInput = {
  id: Scalars['ID']['input'];
};

export enum ZoneType {
  Building = 'BUILDING',
  Floor = 'FLOOR',
  Zone = 'ZONE'
}

export type ZoneUpdateInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type ZonesSortInput = {
  projectId: Scalars['ID']['input'];
  zonesData: Array<SortedZoneData>;
};

export type ZoningFindInput = {
  projectId: Scalars['ID']['input'];
};
